import styled from 'styled-components';

export const MainContainer = styled.main`
  overflow-x: hidden;
  h2 {
    position: relative;
    display: inline-block;
    margin-bottom: ${({ theme }) => theme.spacing.m};
    &::after {
      content: '';
      display: block;
      width: 100%;
      height: 5px;
      position: absolute;
      bottom: -5px;
      left: 0;
    }
  }
`;
